import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getExpandedItems } from "./fulfillment-group-csv-utils";

type Item = FulfillmentGroupData["items"][number];

function formatAmount(amount: number): string {
  return String(Math.round(amount * 1e4) / 1e4);
}

function itemValue(item: Item): number | null {
  return item.unitCost == null ? null : item.unitCost * item.quantity;
}

export function getUnitCostCell(row: FulfillmentGroupData): string {
  const costs = new Set<string>();
  for (const item of row.items ?? []) {
    if (item.unitCost != null) {
      costs.add(formatAmount(item.unitCost));
    }
  }
  return Array.from(costs).join(", ");
}

export function getUnitCostExpandedCell(
  row: FulfillmentGroupData,
  expansionIndex: number,
): string {
  const cost = getExpandedItems(row)[expansionIndex]?.unitCost;
  return cost == null ? "" : formatAmount(cost);
}

export function getTotalCostCell(row: FulfillmentGroupData): string {
  const values = (row.items ?? [])
    .map(itemValue)
    .filter((value): value is number => value !== null);
  return values.length === 0
    ? ""
    : formatAmount(values.reduce((sum, value) => sum + value, 0));
}

export function getTotalCostExpandedCell(
  row: FulfillmentGroupData,
  expansionIndex: number,
): string {
  const item = getExpandedItems(row)[expansionIndex];
  const value = item ? itemValue(item) : null;
  return value === null ? "" : formatAmount(value);
}

export const UnitCostCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Unit cost",
    cell: getUnitCostCell,
    expandedCsvCell: getUnitCostExpandedCell,
  };

export const TotalCostCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Total cost",
    cell: getTotalCostCell,
    expandedCsvCell: getTotalCostExpandedCell,
  };
